import { createV3Queries } from "@query/utils/createV3Queries";
import { invoicesApi } from "@api";

export const queriesInvoices = createV3Queries("invoicesApi", invoicesApi);
